export default {
  GET_INTRODUCER_LOGO: state => {
    return state.introducerLogo;
  },

  GET_ONBOARDING_LOGO: state => {
    return state.onboardingLogo;
  }
};
